import React from "react";
import { useState } from "react";

const SearchButton = () => <button className="btn btn-primary">Search</button>;

const Search = (props) => {
  let [searchInput, setSearchInput] = useState("");
  function handleSearchInput (event) {
    setSearchInput(event.target.value);
  }
  function submitHandler (event) {
    event.preventDefault();
    props.search(searchInput);
    
  }
  return (
    <div className="search">
      <div className="page-header">
        <h4 className="text-left">Search Bookings</h4>
      </div>
      <div className="row search-wrapper">
        <div className="col">
          <form className="form-group search-box" onSubmit={submitHandler}>
            <label htmlFor="customerName">Customer name</label>
            <div className="search-row">
              <input
                type="text"
                id="customerName"
                className="form-control"
                placeholder="Customer name"
                value={searchInput}
                onChange={handleSearchInput}
              />
              <SearchButton />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};


export default Search;

